import GlobalStyles from '@mui/material/GlobalStyles';
import { useTheme } from '@mui/material/styles';
import React from 'react';

import { useIsAssemblyBrandEnabled } from 'src/hooks/useIsAssemblyBrandEnabled';
import { CopilotAdminAuthBackground } from 'src/theme/colors';

export const OnboardingPageLayout: React.FC = ({ children }) => {
  const { isAssemblyBrandEnabled } = useIsAssemblyBrandEnabled();
  const theme = useTheme();

  return (
    <>
      <GlobalStyles
        styles={{
          '*': {
            margin: 0,
            padding: 0,
            boxSizing: 'inherit',
          },
          html: {
            height: '100%',
            width: '100%',
            boxSizing: 'border-box',
            WebkitFontSmoothing: 'antialiased',
            MozOsxFontSmoothing: 'grayscale',
          },
          body: {
            height: '100%',
            width: '100%',
            fontSize: '13px',
            lineHeight: 1.2,
            margin: 0,
            [theme.breakpoints.up('sm')]: {
              backgroundColor: isAssemblyBrandEnabled
                ? 'transparent'
                : CopilotAdminAuthBackground,
            },
          },
          '#app': {
            height: '100%',
            width: '100%',
          },
        }}
      />
      <div className="h-full flex flex-col">
        <div className="w-full m-auto">{children}</div>
      </div>
    </>
  );
};
